import { useCallDataExtractionSlug } from 'app/components/call-data-extraction-slug/useCallDataExtractionSlug'
import { CallDataExtractionSlugShadcnComponent } from 'app/components/call-data-extraction-slug/CallDataExtractionSlugShadcnComponent'

export default function CallData() {
  const hookData = useCallDataExtractionSlug()
  return <CallDataExtractionSlugShadcnComponent {...hookData} />
}
